import React from 'react';
import { Form, OverlayTrigger, Popover } from 'react-bootstrap';
import { Button, Card, Row, Col } from 'react-bootstrap';
import TinymceEditor from 'components/common/TinymceEditor';
import Section from 'components/common/Section';
import Logo from 'components/common/Logo';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRobot } from '@fortawesome/free-solid-svg-icons';
import AiToolsService from './AiToolsService';
import classNames from 'classnames';
import useButtonsGenerator from '../common/functions/useButtonsGenerator';
import { Spinner } from 'react-bootstrap';
import JDModal from './JDModal';
import { useEffect } from 'react';
const HRUKRecruiter = () => {
  const [isLoadingAnalysis, setIsLoadingAnalysis] = React.useState(false);
  const [validated, setValidated] = React.useState(false);
  const [showModal, setShowModal] = React.useState(false);
  const [output, setOutput] = React.useState('');
  const handleSubmit = event => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    analizeJobDescription();
  };
  const validateEmail = email => {

    if (!/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(email)) {
      console.log('Invalid email format');
      return false;
    } else {
      console.log('Valid email:', email);
      return true;
    }
  };
  const [formData, setFormData] = React.useState({
    name: '',
    email: '',
    text: ''
  });
  const handleChange = e => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const analizeJobDescription = () => {
    if (!validateEmail(formData.email) || !formData.name || !formData.text) {
      console.error('Please fill in all required fields.');
      return;
    }
    setIsLoadingAnalysis(true);
    console.log('Form data:', formData);
    AiToolsService.analyzeJobDescription(formData)
      .then(data => {
        console.log('Analyzed job description:', data);
        setIsLoadingAnalysis(false);
        setOutput(data);
        setShowModal(true);

      })
      .catch(error => {
        console.error('Error analyzing job description:', error);
        setIsLoadingAnalysis(false);
        // Handle the error as needed
      });
  };
  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      text: ''
    });
    setShowModal(false);
    setOutput('');
  };
 useEffect(() => {
    setShowModal(false);
 },[]);   
  const buttonsConf = [
    {
      name: isLoadingAnalysis ? (
        <>
          <Spinner
            as="span"
            animation="border"
            size="sm"
            role="status"
            aria-hidden="true"
            className="me-2"
          />
          Analyzing...
        </>
      ) : (
        'Analyse Now'
      ),
      type: 'submit',
      icon: 'faRobot',
      variant: 'primary',
      onClick: () => {
        console.log('Analyse Now');
        analizeJobDescription();
      },
      className: classNames('m-2 btn w-100 w-md-auto')
    },
    {
      name: 'Reset',
      type: 'button',
      icon: 'faUndo',
      variant: 'secondary',
      className: classNames('m-2 btn w-100 w-md-auto'),
      onClick: () => {
        resetForm();
      }
    }
  ];
  const buttonsGenerated = useButtonsGenerator(buttonsConf);
  const popover = (
  <Popover id="popover-basic">
    <Popover.Header as="h3">Write a short description</Popover.Header>
    <Popover.Body>
     For example: "We are looking for a talented developer to join our team. <strong>Salary range is 40k-50k</strong>, remote work possible"
    </Popover.Body>
  </Popover>
);
  return (
    <>
      <Row className="flex-center min-vh-200 py-6">
        <Col sm={10} md={12} lg={6} xl={5} className="col-xxl-4">
          <Logo />
          <Card>
            <Card.Body className="p-4 p-sm-5">
              <h4>Boost your Talent Attraction</h4>
              <p className="mb-4">
                Paste your job description below for a comprehensive AI-driven
                performance report.
              </p>
              <Form
                className="mb-2"
                noValidate
                validated={validated}
              >
                <Form.Group className="mb-3" controlId={'name'}>
                  <Form.Label>{'Your name'}</Form.Label>
                  <Form.Control
                    size="sm"
                    style={{ maxWidth: '100%' }}
                    id={'name'}
                    name={'name'}
                    type={'name'}
                    required={true}
                    onChange={handleChange}
                    placeholder='John Doe'
                    value={formData.name}
                    className={formData.name ? 'is-valid' : 'is-invalid'}
                  />
                </Form.Group>
                <Form.Group className="mb-3" controlId={'email'}>
                  <Form.Label>{'Email'}</Form.Label>
                  <Form.Control
                    size="sm"
                    style={{ maxWidth: '100%' }}
                    id={'email'}
                    name={'email'}
                    type={'email'}
                    placeholder='john.doe@outlook.com'
                    required={true}
                    className={
                      formData.email && validateEmail(formData.email) ? 'is-valid' : 'is-invalid'
                    }
                    onChange={handleChange}
                    value={formData.email}
                  />
                </Form.Group>
                <OverlayTrigger placement="right" overlay={popover} show={!formData.text}>
                <Form.Group className="mb-3" controlId={'text'}>
                  <Form.Label>{'Describe the job'}</Form.Label>
                  <TinymceEditor
                    handleChange={value => {
                      const customEvent = {
                        target: { name: 'text', value: value }
                      };
                      handleChange(customEvent);
                    }}
                    name={'text'}
                    required={true}
                    value={formData.text}
                    placeholder={'Paste your job description here...'}
                  />
                </Form.Group>
                </OverlayTrigger>
              </Form>
            </Card.Body>
            <Card.Footer className="p-sm-5">
              {buttonsGenerated}
              <br />
              <small className="form-text text-muted m-2">
                No credit card required. GDPR compliant.
              </small>
            </Card.Footer>
          </Card>
        </Col>
      </Row>
      {showModal && (<JDModal message={output} showModal={showModal} 
      setShowModal={setShowModal} name={formData.name} />)}
    </>
  );
};

export default HRUKRecruiter;
